{
  "title": "Users and access",
  "intro": "Everyone in your organisation, what they may do and in which projects. Invite people with a one-time link; open a person to change their role or access.",
  "inviteAction": "Invite",
  "search": "Search by name or e-mail",
  "filter": "Show",
  "filters": {
    "all": "Everyone",
    "admin": "Administrators",
    "project_owner": "Project owners",
    "guest": "Guests",
    "mixed": "Owner and guest",
    "none": "Without projects",
    "invited": "Invited"
  },
  "empty": "Nobody found",
  "emptyLead": "No one matches the search. Invite a colleague: they get a link to set a password and a second factor.",
  "name": "Name",
  "kind": "Kind",
  "projects": "Projects",
  "allProjects": "All projects",
  "secondFactor": "Second factor",
  "factorOn": "On",
  "factorOff": "Not set up",
  "lastSignIn": "Last sign-in",
  "never": "Never",
  "statusLabel": "Status",
  "organizationOwner": "Organisation owner",
  "kinds": {
    "admin": "Administrator",
    "project_owner": "Project owner",
    "guest": "Guest",
    "mixed": "Owner and guest",
    "none": "No projects"
  },
  "status": {
    "active": "Active",
    "invited": "Invited",
    "suspended": "Suspended"
  },
  "access": {
    "admin": "Administrator",
    "owner": "Owner",
    "guest": "Guest",
    "none": "No access"
  },
  "projectWithAccess": "{{name}} ({{access}})",
  "accessIn": "Access to {{name}}",
  "projectsLabel": "Projects",
  "projectsHint": "Owner: full rights inside the project, within its budget. Guest: looks only — no changes, no console, no root passwords. A project without access is invisible to the person.",
  "noProjects": "There are no projects yet.",
  "role": {
    "label": "Kind of user",
    "hint": "Administrators see and do everything, including users and provider connections. Members get rights per project.",
    "admin": "Administrator",
    "adminLead": "Sees and does everything: all projects, connections, users and their access.",
    "member": "Member",
    "memberLead": "Works only in the projects given below, as owner or guest."
  },
  "open": "Open",
  "inviteAgain": "Invite again",
  "revoke": "Revoke invitation",
  "revoked": "Invitation for {{email}} revoked",
  "invitationExpires": "Link expires {{when}}",
  "invitationExpired": "Link expired",
  "invite": {
    "title": "Invite a person",
    "lead": "They get a one-time link valid for 7 days to set a password and a second factor.",
    "email": "E-mail",
    "submit": "Create link",
    "createdTitle": "Invitation link",
    "createdLead": "Send this link to {{email}} yourself: CloudServer does not send e-mail yet.",
    "link": "One-time link",
    "linkHint": "Valid for 7 days, works once. It is shown only now — copy it before closing.",
    "copy": "Copy link",
    "copied": "Link copied",
    "copyFailed": "Could not copy; select the link and copy it by hand",
    "done": "Done"
  },
  "stepUp": {
    "title": "Confirm it is you",
    "lead": "Changing who may do what needs your second factor. One confirmation covers changes for five minutes.",
    "passkey": "Confirm with a passkey",
    "code": "Code from the authenticator app",
    "confirm": "Confirm"
  },
  "roleSection": "Role in the organisation",
  "roleSectionLead": "Administrators see everything; members work in the projects given to them.",
  "lockedSelf": "This is you: your own role and status are changed by another administrator.",
  "lockedOwner": "The organisation owner always stays an administrator.",
  "saveRole": "Save role",
  "roleSaved": "Role of {{name}} changed",
  "projectsSection": "Project access",
  "projectsSectionLead": "Which projects this person sees, and whether they may change them.",
  "adminSeesAll": "Administrators see and change every project; there is nothing to set here.",
  "saveAccess": "Save access",
  "accessSaved": "Access of {{name}} changed",
  "securitySection": "Second factor",
  "securitySectionLead": "Everyone needs a passkey or an authenticator app. Reset it when the person lost their device.",
  "passkeys": "Passkeys",
  "authenticator": "Authenticator app",
  "reset": "Reset second factor",
  "resetSelf": "Your own factors are on the Sign-in and security page.",
  "resetTitle": "Reset the second factor of {{name}}?",
  "resetFactors": "Their passkeys and authenticator app are removed.",
  "resetSessions": "They are signed out everywhere at once.",
  "resetNext": "They sign in with their password and set up a new factor before working.",
  "resetDone": "Second factor of {{name}} reset",
  "sessionsSection": "Sessions",
  "sessionsSectionLead": "Devices where this person is signed in now.",
  "noSessions": "Not signed in anywhere.",
  "unknownDevice": "Unknown device",
  "sessionMeta": "{{ip}} · active {{seen}}",
  "activitySection": "Recent activity",
  "activitySectionLead": "What this person did lately, from the audit log.",
  "noActivity": "Nothing recorded yet.",
  "outcome": {
    "success": "Done",
    "denied": "Refused",
    "failed": "Failed"
  },
  "dangerSection": "Suspend or remove",
  "dangerSectionLead": "Suspending is reversible; removing is not.",
  "suspend": "Suspend",
  "suspendTitle": "Suspend {{name}}?",
  "suspendSessions": "They are signed out everywhere at once.",
  "suspendSignIn": "They cannot sign in until reactivated.",
  "suspendKeep": "Their account and project access are kept.",
  "suspended": "{{name}} suspended",
  "reactivate": "Reactivate",
  "reactivateTitle": "Reactivate {{name}}?",
  "reactivateLead": "They can sign in again with the same access as before.",
  "reactivated": "{{name}} can sign in again",
  "remove": "Remove",
  "removeTitle": "Remove {{name}}?",
  "removeAccount": "Their account, sessions and second factors are deleted.",
  "removeHistory": "What they did stays in the history and the audit log.",
  "removeAgain": "To work here again, they need a new invitation.",
  "removed": "{{name}} removed"
}
